import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { BlindsChangedEvent } from '../../../../shared/events/blinds-changed.event';
import { BlindActionsUnion, BlindActionTypes } from './blinds.actions';

export const inRoomBlindsFeatureKey = 'inroom-blinds';

export type BlindState = EntityState<BlindsChangedEvent>;

export function selectBlindIdFromBlind(fanspeed: BlindsChangedEvent) {
  return selectBlindId(fanspeed.HotelCode, fanspeed.Room);
}

export function selectBlindId(hotelCode: string, room: string) {
  return hotelCode + '-' + room;
}

export const adapter: EntityAdapter<BlindsChangedEvent> = createEntityAdapter<BlindsChangedEvent>({
  selectId: selectBlindIdFromBlind,
});

export const initialState: BlindState = adapter.getInitialState();

export function blindsReducer(state: BlindState = initialState, action: BlindActionsUnion) {
  switch (action.type) {
    case BlindActionTypes.UPDATE_BLIND:
      return adapter.upsertOne(action.payload, state);
    default:
      return state;
  }
}

const { selectIds, selectEntities } = adapter.getSelectors();

export const selectBlindIds = selectIds;

export const selectBlindEntities = selectEntities;
